import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import { captureInviterFromUrl } from "@/lib/invites";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import InstallPrompt from "@/components/InstallPrompt";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Feed from "@/pages/Feed";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Testimonies from "@/pages/Testimonies";
import Memories from "@/pages/Memories";
import Events from "@/pages/Events";
import Pricing from "@/pages/Pricing";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ComingSoon from "@/pages/ComingSoon";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Cinema from "@/pages/Cinema";
import CinemaDetail from "@/pages/CinemaDetail";
import Messages from "@/pages/Messages";
import MessageThread from "@/pages/MessageThread";
import MemberProfile from "@/pages/MemberProfile";
import Directory from "@/pages/Directory";
import DirectoryDetail from "@/pages/DirectoryDetail";
import DirectorySubmit from "@/pages/DirectorySubmit";
import Contact from "@/pages/Contact";
import EmergencyHelp from "@/pages/EmergencyHelp";
import Donate, { DonationThanks } from "@/pages/Donate";
import FAQ from "@/pages/FAQ";
import { Terms, Privacy, Guidelines } from "@/pages/Legal";
import Inspiration from "@/pages/Inspiration";
import Music from "@/pages/Music";
import Volunteer from "@/pages/Volunteer";
import LoveThyElder from "@/pages/LoveThyElder";
import Family from "@/pages/Family";
import ConfidenceArise from "@/pages/ConfidenceArise";
import MillionDollarMindset from "@/pages/MillionDollarMindset";
import Shop from "@/pages/Shop";
import BookClub from "@/pages/BookClub";
import BookClubDetail from "@/pages/BookClubDetail";
import CovenantGate from "@/components/CovenantGate";

function App() {
  useEffect(() => {
    captureInviterFromUrl();
  }, []);
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Navbar />
            <CovenantGate />
            <Toaster richColors position="top-right" />
            <InstallPrompt />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
              <Route path="/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
              <Route path="/groups/:id" element={<ProtectedRoute><GroupDetail /></ProtectedRoute>} />
              <Route path="/testimonies" element={<ProtectedRoute><Testimonies /></ProtectedRoute>} />
              <Route path="/memories" element={<ProtectedRoute><Memories /></ProtectedRoute>} />
              <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
              <Route path="/cinema" element={<ProtectedRoute><Cinema /></ProtectedRoute>} />
              <Route path="/cinema/:id" element={<ProtectedRoute><CinemaDetail /></ProtectedRoute>} />
              <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
              <Route path="/messages/:userId" element={<ProtectedRoute><MessageThread /></ProtectedRoute>} />
              <Route path="/u/:userId" element={<ProtectedRoute><MemberProfile /></ProtectedRoute>} />
              <Route path="/directory" element={<ProtectedRoute><Directory /></ProtectedRoute>} />
              <Route path="/directory/submit" element={<ProtectedRoute><DirectorySubmit /></ProtectedRoute>} />
              <Route path="/directory/:id" element={<ProtectedRoute><DirectoryDetail /></ProtectedRoute>} />
              <Route path="/inspiration" element={<ProtectedRoute><Inspiration /></ProtectedRoute>} />
              <Route path="/music" element={<ProtectedRoute><Music /></ProtectedRoute>} />
              <Route path="/volunteer" element={<ProtectedRoute><Volunteer /></ProtectedRoute>} />
              <Route path="/love-thy-elder" element={<ProtectedRoute><LoveThyElder /></ProtectedRoute>} />
              <Route path="/family" element={<Family />} />
              <Route path="/confidence-arise" element={<ConfidenceArise />} />
              <Route path="/million-dollar-mindset" element={<MillionDollarMindset />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/book-club" element={<BookClub />} />
              <Route path="/book-club/clubs/:clubId" element={<BookClubDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/about" element={<About />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/emergency-help" element={<EmergencyHelp />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/thanks" element={<DonationThanks />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/guidelines" element={<Guidelines />} />
              <Route path="/businesses" element={<ComingSoon title="Faith-Led Business Directory" blurb="A curated list of believer-owned businesses you can support — coming soon." />} />
              <Route path="/find-help" element={<ComingSoon title="Find Help" blurb="A confidential, compassionate hub for members who need financial, emotional, or spiritual support." />} />
              <Route path="/churches" element={<ComingSoon title="Find a Church" blurb="A searchable list of local churches by city and denomination." />} />
            </Routes>
            <Footer />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
